module.exports = __webpack_public_path__ + "media/packs/images/flags/ID-8e5fab8b4b6022d847309d0eb951062b.png";